/**
 * Generate VideoObject JSON-LD structured data
 * 
 * This function generates VideoObject schema markup from heroSectionV1 blocks in pageBuilder.
 */

interface PageBuilderBlock {
  type?: string
  typeHandle?: string
  [key: string]: any
}

/**
 * Generate VideoObject JSON-LD structured data from pageBuilder blocks
 * Currently returns a static object, will be generated dynamically from heroSectionV1 block
 */
export function generateVideoObjectFromHeroSection1(pageBuilder: PageBuilderBlock[] = []): {
  '@context': string
  '@type': string
  name: string
  description: string
  thumbnailUrl: string[]
  embedUrl: string
  publisher: {
    '@type': string
    name: string
    logo: {
      '@type': string
      url: string
    }
  }
  transcript: string
} | null {

  // Find block with typeHandle === 'heroSectionV1'
  const heroSectionV1Block = pageBuilder.find(block => block?.typeHandle === 'heroSectionV1')

  if (!heroSectionV1Block) return null

  // Determine video source: direct videoUrl or video file in assetDesktop
  const directVideoUrl = heroSectionV1Block?.['videoUrl']?.['url'] as string | undefined
  const assetUrl = (heroSectionV1Block['assetDesktop'] || [])[0]?.['url'] as string | undefined
  const isAssetVideo = assetUrl
    ? /\.(mp4|webm|mov|m4v|avi|ogg)(\?|#|$)/i.test(assetUrl)
    : false

  // Return null if no valid video source found
  if (!directVideoUrl && (!assetUrl || !isAssetVideo)) {
    return null
  }

  const embedUrl = (directVideoUrl || assetUrl) as string

  const transcript = heroSectionV1Block['heading']['html']
    .replace(/<[^>]*>?/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 1000)

  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": heroSectionV1Block['subheading'] || transcript,
    "description": heroSectionV1Block['description'],
    "thumbnailUrl": [(heroSectionV1Block['previewImageDesktop'] || [])[0]['url']],
    "embedUrl": embedUrl,
    "publisher": {
      "@type": "Organization",
      "name": "Delight.ai",
      "logo": {
        "@type": "ImageObject",
        "url": "https://sendbird.imgix.net/cms/logo.svg"
      }
    },
    transcript
  }
}

